import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CalpadSSIDResoultion } from '../../service/calpad-ssid-resolution';
import { MsgModel } from '../../../../component/common-components/msg/model/msg.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, } from '@angular/material/dialog';
import { ShortDateTime } from '../../../../pipes/short-date-time';

import { resolved } from '../resolved/model/resolved';
import { Student } from '../../../../model/student/student.model';
import { ThemePalette } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { GetPropertyPipe } from '../../../../pipes/get-property.pipe';


const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();

interface CalpadsStudentIndex {
  ID: number;
  CALPADS_STUDENT_ID: number;
  INDEX: number;
  MODIFIED_BY: string;
  MODIFIED_DATE: string;
  RESPONSE: string;
}


@Component({
  selector: 'app-resolved-match-task',
  templateUrl: './resolved-match-task.component.html',
  styleUrl: './resolved-match-task.component.scss'
})

export class ResolvedMatchTaskComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatSort) sortSinf!: MatSort;
  msg: MsgModel = {};
  isLoading = true;
  isLoadingSSID = false;
  idx: CalpadsStudentIndex[] = [];
  matchedSSID: string = '';
  previousSSIDErrorMsg: string = '';
  showPreviousSSIDErrorMsg: boolean = false;

  displayedColumnsSinf = [
    'Name',
    'SSID',
    'DOB',
    'Gender',
    'Birth City',
    'Current School District',
    'Current Grade',
    'Guardian1',
    'Guardian2'
  ];

  displayedColumns = [
    'Name',
    'SSID',
    'DOB',
    'Gender',
    'Birth City',
    'Current School District',
    'Current Grade',
    'Guardian1',
    'Guardian2'
  ];

  tableDataSource = new MatTableDataSource<Student>();
  tableDataSourceSinf = new MatTableDataSource<Student>();
  regionCode: string | null = '';
  studentId: string | null = '';
  student: Student = new Student();
  studentLen: number = 0;
  myPreviousSsid: string | null = '';
  checked = false;
  fromDate: Date | null = null;
  toDate: Date | null = null;

  maxDate = new Date(); // Today


  constructor(
    private calpadSSIDResolution: CalpadSSIDResoultion,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ResolvedMatchTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) {
    //this.regionCode = this.route.snapshot.paramMap.get('code');
    console.log(this.route.snapshot.paramMap)
    this.studentId = data.STUDENT.ID;
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit(): void {
    this.tableDataSource.sort = this.sort;
    this.tableDataSourceSinf.sort = this.sortSinf;
  }

  setupSorting(sortState: Sort) {
    this.tableDataSource.sort = this.sort;
    this.tableDataSourceSinf.sort = this.sortSinf;
  }

  private loadData(): void {
    this.msg = new MsgModel();

    this.calpadSSIDResolution
      .getStudentInfo(this.studentId!)
      .subscribe(res => {

        if (res?.student) {
          this.msg.SUCCESS = true;
          let results: Student[] = [];
          results = Array.isArray(res?.student) ? res.student : [res.student];
          console.log(res.student.PERSON)
          const filteredResults = results.filter(element => {

            if (element.SSID) // highlight the matched SSID row
            {
              this.matchedSSID = element.SSID;
              console.log("set matchedSSID:", this.matchedSSID)
            }

            return (
              element.PERSON?.LAST_NAME ||
              element.PERSON?.FIRST_NAME 
            );
          });

          this.tableDataSource = new MatTableDataSource<Student>(filteredResults);
          this.tableDataSource.sort = this.sort;

          this.tableDataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'Name':
                return [
                  item.PERSON?.LAST_NAME || '',
                  item.PERSON?.SECOND_LAST_NAME || '',
                  item.PERSON?.FIRST_NAME || ''
                ].join(' ').toLowerCase();
              case 'SSID':
                return item.SSID || '';
              case 'DOB':
                return item.DOB ? new ShortDateTime('en-US').transform(item.DOB, 'short') || '' : '';
              case 'Gender':
                return item.SEX ? item.SEX : '';
              case 'BirthCity':
                return item.BIRTH_CITY ? item.BIRTH_CITY : '';
              case 'CurrentSchoolDistrict':
                return item.SCHOOL?.DISTRICT ? item.SCHOOL?.DISTRICT : '';
              case 'CurrentGrade':
                let grade = "";
                // item?.Senr?.GradeLevelCode ? item?.Senr?.GradeLevelCode  : '';
                return grade;
              case 'Guardian1':
                let guardian1: string = "";
                //guardian1 = item?.Senr.Guardian1FirstName ? item?.Senr.Guardian1FirstName  : '';
                return guardian1;
              case 'Guardian2':
                let guardian2: string = "";
                // guardian2 = item?.Senr.Guardian2FirstName ? item?.Senr.Guardian2FirstName  : '';
                return guardian2;
              default:
                return (item as any)[property];
            }
          };

          // now get sinf data
          this.calpadSSIDResolution
            .getResolvedStudentAll(this.studentId!)
            .subscribe(res2 => {
              this.student = res2?.student;
              const indexes = res2?.student?.CALPADS_STUDENTS_INDEXES;

              this.studentLen = indexes.length;

              indexes.forEach((idx: CalpadsStudentIndex) => {

                const responseObj = JSON.parse(idx.RESPONSE);
                const sinf = responseObj?.Sinf;

                if (Array.isArray(sinf)) {
                  results = results.concat(sinf); 
                } else if (sinf) {
                  results.push(sinf); 
                }

                const filteredResults = results.filter(element => {
                 return (
                    element.StudentLegalFirstName ||
                    element.StudentLegalLastName 
                  );
                });
                this.tableDataSourceSinf = new MatTableDataSource<Student>(filteredResults);

                this.tableDataSourceSinf.sort = this.sort;
                this.tableDataSourceSinf.sortingDataAccessor = (item: Student, property) => {
                  const firstStudent = item;
                  switch (property) {
                    case 'Name':
                      return [
                        firstStudent.StudentLegalLastName || '',
                        firstStudent.StudentLegalFirstName 
                      ].join(' ').toLowerCase();
                    case 'SSID':
                      return firstStudent.Ssid || '';
                    case 'DOB':
                      return firstStudent.StudentBirthDate ? new ShortDateTime('en-US').transform(firstStudent.StudentBirthDate, 'short') || '' : '';
                    case 'Gender':
                      return firstStudent.StudentGenderCode ? firstStudent.StudentGenderCode : '';
                    case 'Birth City':
                      return firstStudent.StudentBirthCity ? firstStudent.StudentBirthCity : '';
                    case 'CurrentSchoolDistrict':
                      return firstStudent.SCHOOL?.DISTRICT ? firstStudent.SCHOOL?.DISTRICT : '';
                    case 'CurrentGrade':
                      let grade = "";
                      // item?.Senr?.GradeLevelCode ? item?.Senr?.GradeLevelCode  : '';
                      return grade;
                    case 'Guardian1':
                      let guardian1: string = "";
                      guardian1 = [firstStudent.Guardian1LastName || '', firstStudent.Guardian1FirstName].join(' ').toLowerCase();
                      //guardian1 = item?.Senr.Guardian1FirstName ? item?.Senr.Guardian1FirstName  : '';
                      return guardian1;
                    case 'Guardian2':
                      let guardian2: string = "";
                      guardian2 = [firstStudent.Guardian2LastName || '', firstStudent.Guardian2FirstName].join(' ').toLowerCase();                   
                      // guardian2 = item?.Senr.Guardian2FirstName ? item?.Senr.Guardian2FirstName  : '';
                      return guardian2;
                    default:
                      //return item[0 ? (item[0] as any)[property] : '';
                      return (item as any)[property];
                  }
                };
              });
              this.isLoading = false;

            });
        }
        else {
          this.msg.SUCCESS = false;
          this.msg.MSG = 'No Records Found.';
          this.isLoading = false;
        }
      });
  }

  showPreviousSSID() {
    this.previousSSIDErrorMsg = "";
    this.showPreviousSSIDErrorMsg = false;
    this.isLoadingSSID = true;
    this.calpadSSIDResolution
      .getPreviousSSID(this.studentId!)
      .subscribe(res => {
        this.isLoadingSSID = false;
        if (res?.calpadsStudentSSIDs) {
          this.showPreviousSSIDErrorMsg = false;
          const results = res?.calpadsStudentSSIDs;
          this.myPreviousSsid = results[0].IDENTIFIER_VALUE;
        }
        else
        {
          this.previousSSIDErrorMsg = "There are no previous SSIDs for this child.";
          this.showPreviousSSIDErrorMsg = true;
        }
      });
  }

  displayNames(element: any): string {
    const legalLastName = this.nullToEmpty(element.StudentLegalLastName);
    const aliasLastName = this.nullToEmpty(element.StudentAliasLastName);
    const legalFirstName = this.nullToEmpty(element.StudentLegalFirstName);
    const legalMiddleName = this.nullToEmpty(element.StudentLegalMiddleName);

    let names = legalLastName;
    if (aliasLastName) names += ` ${aliasLastName}`;
    if (legalFirstName) names += `, ${legalFirstName}`;
    if (legalMiddleName) names += ` ${legalMiddleName}`;
    return names.trim();
  }

  nullToEmpty(inStr: string): string {
    if (!inStr) return '';
    return inStr.toLowerCase().includes('null') ? '' : inStr.trim();
  }

  closeRecord(){
    this.dialogRef.close();
  }
}
